<template>
<div id="vinculados" >
    <div>
        <v-breadcrumbs :items="breadcrumbs" >
            <v-icon slot="divider" >forward</v-icon>
        </v-breadcrumbs>
    </div>
    <v-container fluid fill-height>
        <v-layout align-center justify-center>
            <v-flex xs12>
                <base-material-card color="primary" icon="library_books" title="Domicilios Vinculados de la Organización" class="elevation-1 px-5 py-3" >
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn fab dark x-small color="secondary" slot="activator" @click.native="openModal(1)" title="Agregar Registro" v-tippy>
                            <v-icon dark>add</v-icon>
                        </v-btn>
                        <v-dialog v-model="modal" max-width="60%" style=" z-index: 400 !important;" >
                            <v-card>
                                <v-card-title>
                                    <v-card class="primary white--text titulomodal" >
                                        <v-icon class="white--text" >{{
                        update ? "edit" : "add"
                      }}</v-icon>&nbsp;
                                        <span class="subheading" >
                                            <strong>{{ update ? "Actualizar" : "Nuevo" }} Domicilio
                                                Vinculado</strong>
                                        </span>
                                    </v-card>
                                    <v-spacer></v-spacer>
                                    <v-btn icon @click.native="modal = false" class="close_modal" >
                                        <v-icon class="white--text" >cancel</v-icon>
                                    </v-btn>
                                </v-card-title>
                                <v-form ref="form" lazy-validation>
                                    <v-card-text>
                                        <v-container grid-list-md text-xs-center @keyup.enter="guardarDomicilio()" >
                                            <v-layout row wrap>
                                                <v-flex s12 m6 l6>
                                                    <v-text-field name="domicilio" label="Calle y Número" type="text" v-model="model.domicilio" :rules="[rules.required]" maxlength="100" ></v-text-field>
                                                </v-flex>
                                                <v-flex s12 m6 l6>
                                                    <v-text-field name="colonia" label="Colonia" type="text" v-model="model.colonia" :rules="[rules.required]" maxlength="100" ></v-text-field>
                                                </v-flex>
                                            </v-layout>
                                            <v-layout row wrap>
                                                <v-flex s12 m6 l6>
                                                    <v-text-field name="ciudad" label="Ciudad" type="text" v-model="model.ciudad" :rules="[rules.required]" maxlength="100" ></v-text-field>
                                                </v-flex>
                                                <v-flex s12 m6 l6>
                                                    <v-text-field name="codigo_postal" label="CP" type="text" v-model="model.codigo_postal" :rules="[rules.required]" maxlength="5" ></v-text-field>
                                                </v-flex>
                                            </v-layout>
                                            <v-layout row wrap>
                                                <v-flex s12 m6 l6>
                                                    <v-autocomplete v-model="model.pais" :items="paises" :hide-no-data="true" :hide-selected="true" :return-object="true" item-text="nombre" item-value="id_pais" label="Selecciona un País" @input="cargarEstados(1)" :rules="[rules.required]" ></v-autocomplete>
                                                </v-flex>
                                                <v-flex s12 m6 l6>
                                                    <v-autocomplete v-model="model.estado" :items="estados" :hide-no-data="true" :hide-selected="true" :return-object="true" item-text="nombre" item-value="id_estado" label="Selecciona un Estado" :rules="[rules.required]" ></v-autocomplete>
                                                </v-flex>
                                            </v-layout>
                                            <v-layout row wrap>
                                                <v-flex s12 m6 l6>
                                                    <v-text-field name="contacto" label="Nombre de Contacto" type="text" v-model="model.nombre_contacto" :rules="[rules.required]" maxlength="150" ></v-text-field>
                                                </v-flex>
                                                <v-flex s12 m6 l6>
                                                    <v-text-field name="email_contacto" label="Email de Contacto" type="text" v-model="model.email_contacto" :rules="[rules.required, rules.email]" maxlength="50" ></v-text-field>
                                                </v-flex>
                                            </v-layout>
                                            <v-layout row wrap>
                                                <v-flex s12 m6 l6>
                                                    <v-text-field name="tel1" label="Número de teléfono 1" type="text" v-model="model.telefono_1" :rules="[rules.numeric]" maxlength="15" ></v-text-field>
                                                </v-flex>
                                                <v-flex s12 m6 l6>
                                                    <v-text-field name="tel2" label="Número de teléfono 2" type="text" v-model="model.telefono_2" :rules="[rules.numeric]" maxlength="15" ></v-text-field>
                                                </v-flex>
                                            </v-layout>
                                        </v-container>
                                    </v-card-text>
                                </v-form>
                                <v-card-actions>
                                    <v-spacer></v-spacer>
                                    <v-btn @click.native="modal = false" >
                                        <v-icon>cancel</v-icon> Cancelar
                                    </v-btn>
                                    <v-btn color="success" :loading="loading" @click.native="guardarDomicilio()" >
                                        <v-icon>done</v-icon>
                                        {{ update ? "Actualizar" : "Guardar" }}
                                    </v-btn>
                                </v-card-actions>
                            </v-card>
                        </v-dialog>
                    </v-card-actions>

                    <v-card-text>
                        <div id="datagrid" >

                            <v-client-table ref="vuetable" :data="domicilios.items" :columns="columns" :options="options" class="elevation-2 pa-2" >
                                <template slot="noResults" >
                                    <v-alert :value="true" icon="info" color="info" >No se encontro ningun registro</v-alert>
                                </template>

                                <template slot="actions" slot-scope="props" >
                                    <v-speed-dial :id="props.row.id" direction="left" open-on-hover>
                                        <template v-slot:activator>
                                            <v-btn :id="props.row.id" x-small fab dark color="primary" >
                                                <v-icon>reorder</v-icon>
                                            </v-btn>
                                        </template>

                                        <v-btn x-small fab dark color="blue" @click.native="
                          getDomicilio(props.row.id_domicilio_vinculado)
                        " title="Editar Registro" v-tippy>
                                            <v-icon>edit</v-icon>
                                        </v-btn>
                                        <v-btn x-small fab dark color="pink" @click.native="
                          deleteDomicilio(props.row.id_domicilio_vinculado)
                        " title="Eliminar Registro" v-tippy>
                                            <v-icon>delete</v-icon>
                                        </v-btn>
                                    </v-speed-dial>
                                </template>
                            </v-client-table>
                        </div>
                    </v-card-text>
                </base-material-card>
            </v-flex>
        </v-layout>
    </v-container>
</div>
</template>

<script>
import axios from "axios";

export default {
    components: {},
    data: () => ({
        fab: false,
        name: "datagrid",
        columns: [
            "domicilio",
            "colonia",
            "ciudad",
            "nombre_contacto",
            "email_contacto",
            "telefono_1",
            "telefono_2",
            "actions"
        ],
        show_loading: true,
        options: {
            filterable: [
                "domicilio",
                "colonia",
                "ciudad",
                "nombre_contacto",
                "email_contacto"
            ],
            sortable: [
                "domicilio",
                "colonia",
                "ciudad",
                "nombre_contacto",
                "email_contacto"
            ],
            headings: {
                domicilio: "Calle y No.",
                colonia: "Colonia",
                ciudad: "Ciudad",
                estado: "Estado",
                pais: "País",
                nombre_contacto: "Nombre del contacto",
                email_contacto: "Email del contacto",
                telefono_1: "Teléfono Movil del Contacto",
                telefono_2: "Teléfono Local del Contacto",
                codigo_postal: "Código Postal",
                actions: "Operaciones"
            }
        },
        show_loading: true,
        breadcrumbs: [{
                text: "Inicio",
                disabled: false,
                to: "/home"
            },
            {
                text: "Organización",
                disabled: true,
                to: ""
            },
            {
                text: "Datos de la Organización",
                disabled: false,
                to: "domicilio"
            },
            {
                text: "Domicilios Vinculados de la Organización",
                disabled: true,
                to: ""
            }
        ],
        loading: false,
        title: "",
        modal: false,
        update: false,
        pagination: {
            //sortBy: ['modulo', 'categoria'] //TOTAVIA NO ORDENA POR MULTIPLES COLUMNAS,
            //HASTA QUE SE AGREGUE A LAS NUEVAS VERSIONES DE VUETIFY
            sortBy: "ordenar"
        },
        search: "",
        datos_cliente_id: 0,
        model: {
            id_domicilio_vinculado: 0,
            datos_cliente: 0,
            domicilio: "",
            colonia: "",
            ciudad: "",
            estado: "",
            pais: "",
            nombre_contacto: "",
            email_contacto: "",
            telefono_1: "",
            telefono_2: "",
            codigo_postal: ""
        },
        rules: {
            //required : v => !!v || 'Este campo es requerido',
            required: v =>
                !!v ||
                JSON.stringify(v) === JSON.stringify({}) ||
                "Este campo es requerido",

            email: value => {
                const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
                return pattern.test(value) || "Correo electrónico no valido";
            },
            numeric: value => {
                const pattern = /^[\d]*$/;
                return pattern.test(value) || "Solo se permiten números";
            }
        },
        paises: [],
        estados: [],
        domicilios: {
            selected: [],
            headers: [{
                    text: "Domicilio",
                    value: "domicilio",
                    width: "20%"
                },
                {
                    text: "Colonia",
                    value: "colonia",
                    width: "15%"
                },
                {
                    text: "Ciudad",
                    value: "ciudad",
                    width: "15%"
                },
                {
                    text: "Contacto",
                    value: "nombre_contacto",
                    width: "20%"
                },
                {
                    text: "Email",
                    value: "email_contacto",
                    width: "15%"
                },
                {
                    text: "Operaciones",
                    value: "operaciones",
                    align: "center",
                    width: "15%"
                }
            ],
            items: [0]
        }
    }),

    methods: {
        openModal: function (type) {
            if (type === 1) {
                this.limpiarModel();
                this.title = "Nuevo Domicilio";
                this.update = false;
            } else {
                this.title = "Actualizar Domicilio";
                this.update = true;
            }
            this.modal = true;
        },

        limpiarModel: function () {
            this.model.id_domicilio_vinculado = 0;
            this.model.domicilio = "";
            this.model.colonia = "";
            this.model.ciudad = "";
            this.model.estado = "";
            this.model.pais = "";
            this.model.nombre_contacto = "";
            this.model.email_contacto = "";
            this.model.telefono_1 = "";
            this.model.telefono_2 = "";
            this.model.codigo_postal = "";
        },

        guardarDomicilio() {
            const datos = {
                datos_cliente: this.datos_cliente_id,
                domicilio: this.model.domicilio,
                colonia: this.model.colonia,
                ciudad: this.model.ciudad,
                estado: this.model.estado.id_estado,
                pais: this.model.pais.id_pais,
                nombre_contacto: this.model.nombre_contacto,
                email_contacto: this.model.email_contacto,
                telefono_1: this.model.telefono_1,
                telefono_2: this.model.telefono_2,
                codigo_postal: this.model.codigo_postal
            };

            if (!this.$refs.form.validate()) {
                //Alguna operación o mensaje
            } else {
                this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
                var metodo = "post";
                var urlCliente = this.$hostname + "domicilios/";
                if (this.update == true) {
                    metodo = "put";
                    urlCliente += this.model.id_domicilio_vinculado + "/";
                }
                axios({
                        method: metodo,
                        url: urlCliente,
                        data: datos
                    })
                    .then(res => {
                        this.$swal({
                            type: "success",
                            title: "¡Operación Exitosa!",
                            text: "Los datos se guardaron correctamente",
                            footer: ""
                        });
                        this.cargarDomiciliosVinculados();
                        this.$root.$dialogLoader.hide();
                        this.modal = false;
                    })
                    .catch(error => {
                        this.$swal({
                            position: "center",
                            type: "error",
                            title: "¡Operación no Permitida!",
                            text: "Ocurrió un error al guardar los datos"
                            //showConfirmButton: false,
                        });
                        console.log(error);
                        this.cargarDomiciliosVinculados();
                        this.$root.$dialogLoader.hide();
                        this.modal = false;
                    });
            }
        },

        cargarPaises: function () {
            axios
                .get(this.$hostname + "paises/")
                .then(res => {
                    if (typeof res.data !== "undefined") this.paises = res.data;
                    else {
                        this.$swal({
                            type: "warning",
                            title: "Aviso",
                            text: "No se han ingresado datos al catálogo de países",
                            footer: ""
                        });
                    }
                })
                .catch(err => {
                    this.$swal({
                        type: "error",
                        title: "¡Operación no Permitida!",
                        text: "Ocurrió un error al obtener el catálogo de países.",
                        footer: ""
                    });
                    console.log(err);
                });
        },

        //Filtramos los estamos
        cargarEstados: function (opcion) {
            if (opcion == 1)
                //1-Limpiar estado seleccionado, 2-No limpiar
                this.model.estado = "";
            if (this.model.pais.id_pais == null) {
                this.estados = [];
            } else {
                let id_pais = this.model.pais.id_pais;
                axios
                    .post(this.$hostname + "estados/get_estados_pais/", {
                        pais: id_pais
                    })
                    .then(res => {
                        if (typeof res.data !== "undefined") {
                            this.estados = res.data;
                        } else {
                            this.$swal({
                                type: "warning",
                                title: "Aviso",
                                text: "No se encontraron estados para el país seleccionado",
                                footer: ""
                            });
                        }
                    })
                    .catch(err => {
                        this.$swal({
                            type: "error",
                            title: "¡Operación no Permitida!",
                            text: "Ocurrió un error al obtener los estados asociados al país seleccionado.",
                            footer: ""
                        });
                        console.log(err);
                    });
            }
        },

        verificarDatosOrganizacion: function () {
            if (this.$local_storage.get("id_cliente") > 0) {
                var datos = {
                    cliente: this.$local_storage.get("id_cliente")
                };
                axios
                    .post(this.$hostname + "datos-clientes/get_domicilio_cliente/", datos)
                    .then(res => {
                        if (typeof res.data !== "undefined") {
                            this.datos_cliente_id = res.data.id_datos_clientes;
                            this.cargarDomiciliosVinculados();
                        }
                    })
                    .catch(err => {
                        this.$router.push("/clientes/domicilio");
                    });
            }
        },

        cargarDomiciliosVinculados: function () {
            var datos = {
                datos_cliente: this.datos_cliente_id
            };
            axios
                .post(this.$hostname + "domicilios/get_vinculados/", datos)
                .then(res => {
                    if (typeof res.data !== "undefined") {
                        this.domicilios.items = res.data;
                        this.$root.$dialogLoader.hide();
                    }
                })
                .catch(err => {
                    this.$swal({
                        type: "error",
                        title: "¡Operación no Permitida!",
                        text: "Ocurrió un error al obtener los domicilios vinculados de la organización.",
                        footer: ""
                    });
                    console.log(err);
                    this.$root.$dialogLoader.hide();
                });
        },

        getDomicilio: function (id_domicilio) {
            axios
                .get(this.$hostname + "domicilios/" + id_domicilio + "/")
                .then(response => {
                    this.model = response.data;
                    this.cargarEstados(2); //opcion 2-No limpiar estado seleccionado
                    this.openModal(2); //ACTUALIZAR
                })
                .catch(error => {
                    this.$swal({
                        type: "error",
                        title: "¡Operación no Permitida!",
                        text: "Ocurrió un error al obtener el registro",
                        footer: ""
                    });
                });
        }, //getDomicilio

        deleteDomicilio: function (id_domicilio) {
            this.$swal({
                type: "info",
                title: "Cuidado",
                text: "¿Está seguro de eliminar el registro?",
                footer: "",
                showCancelButton: true,
                cancelButtonColor: "#d33",
                confirmButtonColor: "#3085d6",
                confirmButtonText: "Aceptar",
                cancelButtonText: "Cancelar"
            }).then(result => {
                if (result.value)
                    axios
                    .delete(this.$hostname + "domicilios/" + id_domicilio + "/")
                    .then(response => {
                        this.cargarDomiciliosVinculados();
                        this.$swal({
                            type: "success",
                            title: "Operación Exitosa",
                            text: "El registro se eliminó correctamente.",
                            footer: ""
                        });
                    })
                    .catch(error => {
                        this.$swal({
                            type: "error",
                            title: "¡Operación no Permitida!",
                            text: "Ocurrió un error al eliminar el registro",
                            footer: ""
                        });
                    });
            });
        } //delete
    }, //methods
    created: function () {
        this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
        this.model.cliente = this.$local_storage.get("id_cliente");
        this.cargarPaises();
        this.verificarDatosOrganizacion();
    }
};
</script>
